// extracted by mini-css-extract-plugin
export default {"title":"Categories_title__BIc7u","sublist":"Categories_sublist__gWaTB","item":"Categories_item__RBV65","itemActive":"Categories_itemActive__6fF3I"};